import React from "react";
import { Link, useLocation } from "react-router-dom";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { connect } from "react-redux";

const Breadcrumb = ({ user }) => {
  const location = useLocation();

  return (
    <>
      <div className="d-flex bread-crumb align-items-center ">
        <>
          <Link
            style={{ textDecoration: "none", color: "#fff" }}
            to="/voting/indashyikirwa"
            className={` px-1 rounded   ${
              location.pathname.includes("/voting/indashyikirwa")
                ? " active  "
                : " "
            }`}
          >
            <span className="text-truncate menu-item">Indashyikirwa</span>
          </Link>
          {["2000000000-010200000000000000"].includes(
            user?.selectedEntitySector?.entityId
          ) && (
            <>
              <HorizontalRuleIcon className="rotated" />
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to="/voting/idc"
                className={` px-1 rounded   ${
                  location.pathname.includes("/voting/idc") ? " active  " : " "
                }`}
              >
                <span className="text-truncate menu-item">
                  Internal Disciplinary Committee
                </span>
              </Link>
            </>
          )}
        </>
      </div>
    </>
  );
};

const mapStateToProps = ({ user }) => {
  return { user };
};
export default connect(mapStateToProps, {})(Breadcrumb);
